import { render, staticRenderFns } from "./AdminCompaniesWidget.vue?vue&type=template&id=6cee0992"
import script from "./AdminCompaniesWidget.vue?vue&type=script&lang=js"
export * from "./AdminCompaniesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports